// Below are built-in components that are available in the app, it's recommended to keep them as is

import { BYOCServerWrapper, NextjsContentSdkComponent, FEaaSServerWrapper } from '@sitecore-content-sdk/nextjs';
import { Form } from '@sitecore-content-sdk/nextjs';

// end of built-in components
import * as Title from 'src/components/Title';
import * as RowSplitter from 'src/components/RowSplitter';
import * as RichText from 'src/components/RichText';
import * as Promo from 'src/components/Promo';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as PageContent from 'src/components/PageContent';
import * as Navigation from 'src/components/Navigation';
import * as LinkList from 'src/components/LinkList';
import * as Image from 'src/components/Image';
import * as ContentBlock from 'src/components/ContentBlock';
import * as Container from 'src/components/Container';
import * as ColumnSplitter from 'src/components/ColumnSplitter';
import * as SkipNav from 'src/components/authorable/shared/site-structure/SkipNav/SkipNav';
import * as MainLayout from 'src/components/authorable/shared/site-structure/MainLayout/MainLayout';
import * as LanguageSelector from 'src/components/authorable/shared/site-structure/Header/LanguageSelector';
import * as HeaderMobile from 'src/components/authorable/shared/site-structure/Header/HeaderMobile';
import * as HeaderDesktop from 'src/components/authorable/shared/site-structure/Header/HeaderDesktop';
import * as Header from 'src/components/authorable/shared/site-structure/Header/Header';
import * as Footer from 'src/components/authorable/shared/site-structure/Footer/Footer';
import * as BreadcrumbClient from 'src/components/authorable/shared/site-structure/Breadcrumb/BreadcrumbClient';
import * as Breadcrumb from 'src/components/authorable/shared/site-structure/Breadcrumb/Breadcrumb';
import * as BackToTop from 'src/components/authorable/shared/site-structure/BackToTop/BackToTop';
import * as SearchResult from 'src/components/authorable/shared/search/SearchResult';
import * as ReportsAndInsightsList from 'src/components/authorable/shared/search/ReportsAndInsightsList';
import * as RelatedExpertCommentsClient from 'src/components/authorable/shared/search/RelatedExpertCommentsClient';
import * as RelatedExpertComments from 'src/components/authorable/shared/search/RelatedExpertComments';
import * as MyClient from 'src/components/authorable/shared/search/MyClient';
import * as GlobalSearchInput from 'src/components/authorable/shared/search/GlobalSearchInput';
import * as ExpertList from 'src/components/authorable/shared/search/ExpertList';
import * as ExpertCommentsOnNews from 'src/components/authorable/shared/search/ExpertCommentsOnNews';
import * as ClientStories from 'src/components/authorable/shared/search/ClientStories';
import * as ArticleSearch from 'src/components/authorable/shared/search/ArticleSearch';
import * as RelatedArticles from 'src/components/authorable/shared/page-specific/RelatedArticles';
import * as PopularArticlesClient from 'src/components/authorable/shared/page-specific/PopularArticlesClient';
import * as PopularArticles from 'src/components/authorable/shared/page-specific/PopularArticles';
import * as ConveyancingCalculator from 'src/components/authorable/shared/page-specific/ConveyancingCalculator';
import * as ArticleListingClient from 'src/components/authorable/shared/page-specific/ArticleListingClient';
import * as ArticleListing from 'src/components/authorable/shared/page-specific/ArticleListing';
import * as ArticleContentClient from 'src/components/authorable/shared/page-specific/ArticleContentClient';
import * as ArticleContent from 'src/components/authorable/shared/page-specific/ArticleContent';
import * as ArticleCategoryTabsClient from 'src/components/authorable/shared/page-specific/ArticleCategoryTabsClient';
import * as ArticleCategoryTabs from 'src/components/authorable/shared/page-specific/ArticleCategoryTabs';
import * as Article from 'src/components/authorable/shared/page-specific/Article';
import * as DynamicForm from 'src/components/authorable/shared/other/DynamicForm';
import * as CustomForm from 'src/components/authorable/shared/other/CustomForm';
import * as Share from 'src/components/authorable/shared/media/Share';
import * as InlineVideo from 'src/components/authorable/shared/media/InlineVideo';
import * as InlineImage from 'src/components/authorable/shared/media/InlineImage';
import * as InlineIFrame from 'src/components/authorable/shared/media/InlineIFrame';
import * as VideoCardItem from 'src/components/authorable/shared/lists/VideoCardItem';
import * as TestimonialTabs from 'src/components/authorable/shared/lists/TestimonialTabs';
import * as TestimonialTabItem from 'src/components/authorable/shared/lists/TestimonialTabItem';
import * as TestimonialCardItem from 'src/components/authorable/shared/lists/TestimonialCardItem';
import * as TabItem from 'src/components/authorable/shared/lists/TabItem';
import * as Tab from 'src/components/authorable/shared/lists/Tab';
import * as StatsItem from 'src/components/authorable/shared/lists/StatsItem';
import * as Stats from 'src/components/authorable/shared/lists/Stats';
import * as ServiceTabs from 'src/components/authorable/shared/lists/ServiceTabs';
import * as ServiceTabItem from 'src/components/authorable/shared/lists/ServiceTabItem';
import * as ServiceTabCardItem from 'src/components/authorable/shared/lists/ServiceTabCardItem';
import * as ServiceCardItem from 'src/components/authorable/shared/lists/ServiceCardItem';
import * as ServiceCardCarousel from 'src/components/authorable/shared/lists/ServiceCardCarousel';
import * as ServiceBannerItem from 'src/components/authorable/shared/lists/ServiceBannerItem';
import * as ServiceBanner from 'src/components/authorable/shared/lists/ServiceBanner';
import * as LocationsBlockClient from 'src/components/authorable/shared/lists/LocationsBlockClient';
import * as LocationsBlock from 'src/components/authorable/shared/lists/LocationsBlock';
import * as LinkListBlock from 'src/components/authorable/shared/lists/LinkListBlock';
import * as FileList from 'src/components/authorable/shared/lists/FileList';
import * as ExpertCardContentBlockClient from 'src/components/authorable/shared/lists/ExpertCardContentBlockClient';
import * as ExpertCardContentBlock from 'src/components/authorable/shared/lists/ExpertCardContentBlock';
import * as ExpertCard from 'src/components/authorable/shared/lists/ExpertCard';
import * as ContextualNavItem from 'src/components/authorable/shared/lists/ContextualNavItem';
import * as ContextualNavClient from 'src/components/authorable/shared/lists/ContextualNavClient';
import * as ContextualNav from 'src/components/authorable/shared/lists/ContextualNav';
import * as ClientStoriesCarouselItem from 'src/components/authorable/shared/lists/ClientStoriesCarouselItem';
import * as ClientStoriesCarousel from 'src/components/authorable/shared/lists/ClientStoriesCarousel';
import * as CarouselItem from 'src/components/authorable/shared/lists/CarouselItem';
import * as Carousel from 'src/components/authorable/shared/lists/Carousel';
import * as CardList from 'src/components/authorable/shared/lists/CardList';
import * as CardItem from 'src/components/authorable/shared/lists/CardItem';
import * as AwardsAndAccreditations from 'src/components/authorable/shared/lists/AwardsAndAccreditations';
import * as AccordionItem from 'src/components/authorable/shared/lists/AccordionItem';
import * as AccordionBlock from 'src/components/authorable/shared/lists/AccordionBlock';
import * as Accordion from 'src/components/authorable/shared/lists/Accordion';
import * as SidebarLayout from 'src/components/authorable/shared/layout/SidebarLayout';
import * as Section from 'src/components/authorable/shared/layout/Section';
import * as SearchMain from 'src/components/authorable/shared/layout/SearchMain';
import * as JumpNavSection from 'src/components/authorable/shared/layout/JumpNavSection';
import * as JumpNavContainer from 'src/components/authorable/shared/layout/JumpNavContainer';
import * as Divider from 'src/components/authorable/shared/layout/Divider';
import * as ContainerFullWidth from 'src/components/authorable/shared/layout/ContainerFullWidth';
import * as ContainerFullBleed from 'src/components/authorable/shared/layout/ContainerFullBleed';
import * as ContainerCenter75 from 'src/components/authorable/shared/layout/ContainerCenter-75';
import * as Container7525 from 'src/components/authorable/shared/layout/Container-75-25';
import * as Container5050 from 'src/components/authorable/shared/layout/Container-50-50';
import * as Container2575 from 'src/components/authorable/shared/layout/Container-25-75';
import * as ContactUsContainer from 'src/components/authorable/shared/layout/ContactUsContainer';
import * as ArticleMain from 'src/components/authorable/shared/layout/ArticleMain';
import * as WillsForm from 'src/components/authorable/shared/content/WillsForm';
import * as TextContentBlock from 'src/components/authorable/shared/content/TextContentBlock';
import * as Tags from 'src/components/authorable/shared/content/Tags';
import * as RelatedProfiles from 'src/components/authorable/shared/content/RelatedProfiles';
import * as RTE from 'src/components/authorable/shared/content/RTE';
import * as Quote from 'src/components/authorable/shared/content/Quote';
import * as ProfileBlock from 'src/components/authorable/shared/content/ProfileBlock';
import * as ProfileAccordionItem from 'src/components/authorable/shared/content/ProfileAccordionItem';
import * as PageTitle from 'src/components/authorable/shared/content/PageTitle';
import * as OverlapCard from 'src/components/authorable/shared/content/OverlapCard';
import * as OfficeLocations from 'src/components/authorable/shared/content/OfficeLocations';
import * as MyComments from 'src/components/authorable/shared/content/MyComments';
import * as Modal from 'src/components/authorable/shared/content/Modal';
import * as LocationCard from 'src/components/authorable/shared/content/LocationCard';
import * as LiveChatdynamic from 'src/components/authorable/shared/content/LiveChat.dynamic';
import * as LiveChat from 'src/components/authorable/shared/content/LiveChat';
import * as LatestNews from 'src/components/authorable/shared/content/LatestNews';
import * as KeyInformationWrapper from 'src/components/authorable/shared/content/KeyInformationWrapper';
import * as KeyInformation from 'src/components/authorable/shared/content/KeyInformation';
import * as KeyContacts from 'src/components/authorable/shared/content/KeyContacts';
import * as KeyContactWrapperClient from 'src/components/authorable/shared/content/KeyContactWrapperClient';
import * as KeyContactWrapper from 'src/components/authorable/shared/content/KeyContactWrapper';
import * as Hero from 'src/components/authorable/shared/content/Hero';
import * as FeatureSidebySide from 'src/components/authorable/shared/content/FeatureSidebySide';
import * as Feature from 'src/components/authorable/shared/content/Feature';
import * as ExpertHero from 'src/components/authorable/shared/content/ExpertHero';
import * as CodeEmbed from 'src/components/authorable/shared/content/CodeEmbed';
import * as BoardMembers from 'src/components/authorable/shared/content/BoardMembers';
import * as Alert from 'src/components/authorable/shared/content/Alert';
import * as TrustpilotSkeleton from 'src/components/authorable/shared/content/TrustpilotReviews/TrustpilotSkeleton';
import * as TrustpilotReviews from 'src/components/authorable/shared/content/TrustpilotReviews/TrustpilotReviews';

export const componentMap = new Map<string, NextjsContentSdkComponent>([
  ['BYOCWrapper', BYOCServerWrapper],
  ['FEaaSWrapper', FEaaSServerWrapper],
  ['Form', { ...Form, componentType: 'client' }],
  ['Title', { ...Title }],
  ['RowSplitter', { ...RowSplitter }],
  ['RichText', { ...RichText }],
  ['Promo', { ...Promo }],
  ['PartialDesignDynamicPlaceholder', { ...PartialDesignDynamicPlaceholder }],
  ['PageContent', { ...PageContent }],
  ['Navigation', { ...Navigation, componentType: 'client' }],
  ['LinkList', { ...LinkList }],
  ['Image', { ...Image }],
  ['ContentBlock', { ...ContentBlock, componentType: 'client' }],
  ['Container', { ...Container }],
  ['ColumnSplitter', { ...ColumnSplitter }],
  ['SkipNav', { ...SkipNav }],
  ['MainLayout', { ...MainLayout, componentType: 'client' }],
  ['LanguageSelector', { ...LanguageSelector, componentType: 'client' }],
  ['HeaderMobile', { ...HeaderMobile, componentType: 'client' }],
  ['HeaderDesktop', { ...HeaderDesktop, componentType: 'client' }],
  ['Header', { ...Header, componentType: 'client' }],
  ['Footer', { ...Footer }],
  ['BreadcrumbClient', { ...BreadcrumbClient, componentType: 'client' }],
  ['Breadcrumb', { ...Breadcrumb }],
  ['BackToTop', { ...BackToTop, componentType: 'client' }],
  ['SearchResult', { ...SearchResult, componentType: 'client' }],
  ['ReportsAndInsightsList', { ...ReportsAndInsightsList, componentType: 'client' }],
  ['RelatedExpertCommentsClient', { ...RelatedExpertCommentsClient, componentType: 'client' }],
  ['RelatedExpertComments', { ...RelatedExpertComments }],
  ['MyClient', { ...MyClient }],
  ['GlobalSearchInput', { ...GlobalSearchInput, componentType: 'client' }],
  ['ExpertList', { ...ExpertList, componentType: 'client' }],
  ['ExpertCommentsOnNews', { ...ExpertCommentsOnNews, componentType: 'client' }],
  ['ClientStories', { ...ClientStories, componentType: 'client' }],
  ['ArticleSearch', { ...ArticleSearch, componentType: 'client' }],
  ['RelatedArticles', { ...RelatedArticles, componentType: 'client' }],
  ['PopularArticlesClient', { ...PopularArticlesClient, componentType: 'client' }],
  ['PopularArticles', { ...PopularArticles }],
  ['ConveyancingCalculator', { ...ConveyancingCalculator, componentType: 'client' }],
  ['ArticleListingClient', { ...ArticleListingClient, componentType: 'client' }],
  ['ArticleListing', { ...ArticleListing }],
  ['ArticleContentClient', { ...ArticleContentClient, componentType: 'client' }],
  ['ArticleContent', { ...ArticleContent }],
  ['ArticleCategoryTabsClient', { ...ArticleCategoryTabsClient, componentType: 'client' }],
  ['ArticleCategoryTabs', { ...ArticleCategoryTabs }],
  ['Article', { ...Article }],
  ['DynamicForm', { ...DynamicForm, componentType: 'client' }],
  ['CustomForm', { ...CustomForm, componentType: 'client' }],
  ['Share', { ...Share, componentType: 'client' }],
  ['InlineVideo', { ...InlineVideo, componentType: 'client' }],
  ['InlineImage', { ...InlineImage, componentType: 'client' }],
  ['InlineIFrame', { ...InlineIFrame, componentType: 'client' }],
  ['VideoCardItem', { ...VideoCardItem, componentType: 'client' }],
  ['TestimonialTabs', { ...TestimonialTabs, componentType: 'client' }],
  ['TestimonialTabItem', { ...TestimonialTabItem, componentType: 'client' }],
  ['TestimonialCardItem', { ...TestimonialCardItem, componentType: 'client' }],
  ['TabItem', { ...TabItem, componentType: 'client' }],
  ['Tab', { ...Tab, componentType: 'client' }],
  ['StatsItem', { ...StatsItem, componentType: 'client' }],
  ['Stats', { ...Stats, componentType: 'client' }],
  ['ServiceTabs', { ...ServiceTabs, componentType: 'client' }],
  ['ServiceTabItem', { ...ServiceTabItem, componentType: 'client' }],
  ['ServiceTabCardItem', { ...ServiceTabCardItem, componentType: 'client' }],
  ['ServiceCardItem', { ...ServiceCardItem, componentType: 'client' }],
  ['ServiceCardCarousel', { ...ServiceCardCarousel, componentType: 'client' }],
  ['ServiceBannerItem', { ...ServiceBannerItem, componentType: 'client' }],
  ['ServiceBanner', { ...ServiceBanner, componentType: 'client' }],
  ['LocationsBlockClient', { ...LocationsBlockClient, componentType: 'client' }],
  ['LocationsBlock', { ...LocationsBlock }],
  ['LinkListBlock', { ...LinkListBlock, componentType: 'client' }],
  ['FileList', { ...FileList, componentType: 'client' }],
  ['ExpertCardContentBlockClient', { ...ExpertCardContentBlockClient, componentType: 'client' }],
  ['ExpertCardContentBlock', { ...ExpertCardContentBlock }],
  ['ExpertCard', { ...ExpertCard, componentType: 'client' }],
  ['ContextualNavItem', { ...ContextualNavItem }],
  ['ContextualNavClient', { ...ContextualNavClient, componentType: 'client' }],
  ['ContextualNav', { ...ContextualNav }],
  ['ClientStoriesCarouselItem', { ...ClientStoriesCarouselItem }],
  ['ClientStoriesCarousel', { ...ClientStoriesCarousel, componentType: 'client' }],
  ['CarouselItem', { ...CarouselItem, componentType: 'client' }],
  ['Carousel', { ...Carousel, componentType: 'client' }],
  ['CardList', { ...CardList, componentType: 'client' }],
  ['CardItem', { ...CardItem, componentType: 'client' }],
  ['AwardsAndAccreditations', { ...AwardsAndAccreditations, componentType: 'client' }],
  ['AccordionItem', { ...AccordionItem, componentType: 'client' }],
  ['AccordionBlock', { ...AccordionBlock, componentType: 'client' }],
  ['Accordion', { ...Accordion, componentType: 'client' }],
  ['SidebarLayout', { ...SidebarLayout }],
  ['Section', { ...Section, componentType: 'client' }],
  ['SearchMain', { ...SearchMain }],
  ['JumpNavSection', { ...JumpNavSection, componentType: 'client' }],
  ['JumpNavContainer', { ...JumpNavContainer, componentType: 'client' }],
  ['Divider', { ...Divider, componentType: 'client' }],
  ['ContainerFullWidth', { ...ContainerFullWidth }],
  ['ContainerFullBleed', { ...ContainerFullBleed }],
  ['ContainerCenter-75', { ...ContainerCenter75 }],
  ['Container-75-25', { ...Container7525 }],
  ['Container-50-50', { ...Container5050 }],
  ['Container-25-75', { ...Container2575 }],
  ['ContactUsContainer', { ...ContactUsContainer, componentType: 'client' }],
  ['ArticleMain', { ...ArticleMain, componentType: 'client' }],
  ['WillsForm', { ...WillsForm }],
  ['TextContentBlock', { ...TextContentBlock, componentType: 'client' }],
  ['Tags', { ...Tags, componentType: 'client' }],
  ['RelatedProfiles', { ...RelatedProfiles, componentType: 'client' }],
  ['RTE', { ...RTE, componentType: 'client' }],
  ['Quote', { ...Quote, componentType: 'client' }],
  ['ProfileBlock', { ...ProfileBlock, componentType: 'client' }],
  ['ProfileAccordionItem', { ...ProfileAccordionItem, componentType: 'client' }],
  ['PageTitle', { ...PageTitle, componentType: 'client' }],
  ['OverlapCard', { ...OverlapCard, componentType: 'client' }],
  ['OfficeLocations', { ...OfficeLocations, componentType: 'client' }],
  ['MyComments', { ...MyComments }],
  ['Modal', { ...Modal, componentType: 'client' }],
  ['LocationCard', { ...LocationCard, componentType: 'client' }],
  ['LiveChat', { ...LiveChatdynamic, ...LiveChat }],
  ['LatestNews', { ...LatestNews, componentType: 'client' }],
  ['KeyInformationWrapper', { ...KeyInformationWrapper, componentType: 'client' }],
  ['KeyInformation', { ...KeyInformation, componentType: 'client' }],
  ['KeyContacts', { ...KeyContacts, componentType: 'client' }],
  ['KeyContactWrapperClient', { ...KeyContactWrapperClient, componentType: 'client' }],
  ['KeyContactWrapper', { ...KeyContactWrapper }],
  ['Hero', { ...Hero, componentType: 'client' }],
  ['FeatureSidebySide', { ...FeatureSidebySide, componentType: 'client' }],
  ['Feature', { ...Feature, componentType: 'client' }],
  ['ExpertHero', { ...ExpertHero }],
  ['CodeEmbed', { ...CodeEmbed, componentType: 'client' }],
  ['BoardMembers', { ...BoardMembers, componentType: 'client' }],
  ['Alert', { ...Alert, componentType: 'client' }],
  ['TrustpilotSkeleton', { ...TrustpilotSkeleton }],
  ['TrustpilotReviews', { ...TrustpilotReviews, componentType: 'client' }],
]);

export default componentMap;
